import React from 'react';
// import PropTypes from 'prop-types';
import { principalPanelStyles } from './styles';
import { Button, Container, CssBaseline, Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { history } from '../../helpers/history';
// import { Carousel } from 'react-responsive-carousel';
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from 'react-material-ui-carousel'
import { Fingerprint, Person } from '@mui/icons-material';
//import { sendMobile } from '../../functions/mobile';
//import { openLink } from '../../functions/core-actions';
//import ImageButton from '../../components/Complements/ImageButton';
//import ImageButtonBig from '../../components/Complements/ImageButtonBig';
//import Image from '../../components/Complements/Image';

const Item = (data) => {
  //const classes = principalPanelStyles()
  const { item } = data
  // console.log('recibo los items ', img)
  return (
    <img src={process.env.PUBLIC_URL + item.img} alt={item.alt} style={{ width: '100%', margin: '0px', marginTop: '20px', minHeight: '255px' }} />
  )
}

/* const ImageSrc = styled('span')({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: 'cover',
  backgroundPosition: 'center 40%',
});

const ImageBackdrop = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0,
  transition: theme.transitions.create('opacity'),
})); */


const PrincipalPanel = props => {
  const { finguerprint } = props
  const classes = principalPanelStyles()
  const items = (isMobile) ? [
    { img: '/images/Carousel/1.png', alt: 'carousel1' },
    { img: '/images/Carousel/2.png', alt: 'carousel2' },
    { img: '/images/Carousel/3.png', alt: 'carousel3' },
    { img: '/images/Carousel/4.png', alt: 'carousel4' },
    { img: '/images/Carousel/5.png', alt: 'carousel5' },
  ] : [
    { img: '/images/Carousel/1.png', alt: 'carousel1' },
    { img: '/images/Carousel/2.png', alt: 'carousel2' },
    { img: '/images/Carousel/3.png', alt: 'carousel3' },
    { img: '/images/Carousel/4.png', alt: 'carousel4' },
    { img: '/images/Carousel/5.png', alt: 'carousel5' },
  ]
  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.paper}>
        <br />
        {
          isMobile ?
            <img src={process.env.PUBLIC_URL + '/images/logo_movil_principal.png'} alt="Logo" style={{ width: '50%'/* , height: '100%' */ }} /> :
            <img src={process.env.PUBLIC_URL + '/images/logo_home.png'} alt="Logo" style={{ width: '70%', height: '80%' }} />
        }

        <div style={{ height: 340 }}>
        {
          isMobile ?
            <Carousel fullHeightHover={false} animation='slide'
              indicatorIconButtonProps={{
                style: {
                  color: '#efefef' // 2
                }
              }}
              activeIndicatorIconButtonProps={{
                style: {
                  color: '#2E2757' // 2
                }
              }} /* className={classes.Carousel} */
              
            >
              {
                items.map((item, i) => <Item key={i} item={item} />)
              }
            </Carousel> :
            ''
        }
        </div>


        <Grid container justifyContent="center" className={classes.divStandard} style={{ marginTop: '20px',}}>
          <Grid item xs={10} sm={8} >
            <div style={{
              color: '#2E2757',
              fontSize: '1.2rem',
              //fontFamily: 'MyriadPro-SemiboldItalic',
              textAlign: 'center',
              marginBottom: '20px'
              /* width : "140px" */
            }}>Seleccione su opción de acceso</div>

          </Grid>
          <Grid item xs={10} sm={8} >
            <Grid container /* spacing={4}  */
              direction="row"
              justifyContent="space-evenly"
              alignItems="center">
              <Grid item xs={5} sm={6} container justifyContent="center" style={{ minWidth: '80px', width: '100%', padding: '0px' }}>
                <Button
                  color='primary'
                  variant='contained'
                  onClick={() => history.push('/login')}
                  style={{ width: 112, height: 112, padding: '0px', fontSize: 12, textTransform: "capitalize", borderRadius: 16 }}
                >
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <Person style={{ fontSize: 70 }} />
                    <span>Usuario y <br/>contraseña</span>
                  </div>
                </Button>
              </Grid>
              <Grid item xs={5} sm={6} container justifyContent="center" style={{ minWidth: '80px', width: '100%', padding: '0px' }} >
                <Button
                  variant='contained'
                  fullWidth
                  color='primary'
                  onClick={finguerprint}
                  style={{ width: 112, height: 112, padding: '0px', fontSize: 12, textTransform: "capitalize", borderRadius: 16 }}
                >
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: 112 }}>
                    <Fingerprint style={{ fontSize: 70 }} />
                    <span>Biometría</span>
                  </div>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* <div style={{
          color: "#459334",
          marginTop: '20px',
          marginBottom: '0px',
          fontSize: '1.2rem',
          //fontFamily: 'MyriadPro-Bold',
        }}>SERVICIOS EN LÍNEA
        </div> */}
        <Grid container justifyContent="center">
          <Grid item xs={10} sm={8} style={{ /* borderTop: '1px solid #459334', */ paddingTop: '10px' }}>
            <Grid container justifyContent="space-evenly" spacing={2}>
              {/* <Grid item xs={3} sm={3} container justifyContent="center">
                <Button size="small"
                  onClick={() => history.push('/login')}
                  style={{minWidth: '55px'}}
                ><img src={process.env.PUBLIC_URL + '/buttons/agencias.png'} alt="Logo" style={{ width: '100%' }} />
                </Button>
              </Grid>
              <Grid item xs={3} sm={3}>
                <Button size="small"
                  onClick={() => history.push('/login')}
                  style={{minWidth: '55px'}}
                ><img src={process.env.PUBLIC_URL + '/buttons/tarjeta_visa.png'} alt="Logo" style={{ width: '100%' }} />
                </Button>
              </Grid>
              <Grid item xs={3} sm={3}>
                <Button size="small"
                  onClick={() => history.push('/login')}
                  style={{minWidth: '55px'}}
                ><img src={process.env.PUBLIC_URL + '/buttons/creditos.png'} alt="Logo" style={{ width: '100%' }} />
                </Button>
              </Grid> */}
              {/*<Grid item xs={5} sm={6} container justifyContent="center">
                <Button size="small"
                  onClick={() => history.push('/login')}
                  style={{ minWidth: '55px', padding:'0px' }}
                // variant="contained"
                /* className={classes.button_pp}
                style={{
                  fontSize: '0.875rem',
                  color: 'white',
                  background: '#459334',
                  "&:hover": {
                    backgroundColor: "#459334"
                  },
                  borderRadius: "8px",
                  border: "1px solid #fffffe",
                  //fontFamily: "Roboto-Bold",
                  margin: "auto"
                }} */
                // className={classes.button}

                //size="medium"
                /*><img src={process.env.PUBLIC_URL + '/buttons/ubicanos.png'} alt="Logo" style={{ width: '100%' }} />
                </Button>
              </Grid>*/}
              {/*<Grid item xs={5} sm={6} container justifyContent="center">
                <Button size="small"
                  onClick={() => history.push('/login')}
                  style={{ minWidth: '55px', padding:'0px' }}
                ><img src={process.env.PUBLIC_URL + '/buttons/contactanos.png'} alt="Logo" className={classes.buttonPrincipalSecundary} />
                </Button>
            </Grid>*/}
            </Grid>
          </Grid>
        </Grid>
        <br></br>
        {/* {
          isMobile ?
            <img src={process.env.PUBLIC_URL + '/images/calificacion_riesgos.png'} alt="Logo" style={{ width: '40%' }} /> :
            <img src={process.env.PUBLIC_URL + '/images/calificacion_riesgos.png'} alt="Logo" style={{ width: '50%' }} />
        } */}
        <br></br>
      </div>
    </Container>
  );
};

PrincipalPanel.propTypes = {

};

export default PrincipalPanel;